<template>
  <div id="LocalInventoryMgmt" class="local-inventory-mgmt-page purchase-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>本地库存</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" v-model="params.productType" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品颜色</span>
            <el-select placeholder="全部" size="small" v-model="params.productColor" clearable filterable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">机型</span>
            <el-select placeholder="全部" size="small" v-model="productModel" clearable filterable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">备货类型</span>
            <el-select placeholder="全部" size="small" v-model="params.stockCycleType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="平销" :value="1"></el-option>
              <el-option label="做排名" :value="2"></el-option>
              <el-option label="新品推广" :value="3"></el-option>
              <el-option label="清库存" :value="4"></el-option>
              <el-option label="禁止采购" :value="5"></el-option>
              <el-option label="禁止出库" :value="6"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">共 {{ total }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="getData">查询</el-button>
            <el-button size="small" plain>
              <download-excel :data="exportDataList" :fields="exportTitles" :name="getExportName()">导出本地库存</download-excel>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          ref="table"
          :data="dataList"
          border
          stripe
          size="small"
          :height="screenHeight"
          :highlight-current-row="true"
          class="mgmt-table local-inventory-table"
          header-cell-class-name="table-header-cell"
          show-summary
          :summary-method="getSummaries"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="shopName" label="店铺" width="80" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" label="产品名称" min-width="140" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="sku" label="SKU" min-width="220" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="fnsku" label="FNSKU" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productColorName" label="产品颜色" width="88" sortable></el-table-column>
          <el-table-column prop="purchaseColorName" label="采购颜色" width="88" sortable></el-table-column>
          <el-table-column prop="model" label="机型" width="92" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="inPurchase" label="采购中" width="80" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="localInventory" label="本地库存" width="88" align="right" sortable class-name="amount-col">
            <template slot-scope="scope">
              <span :class="{ 'highlight-inventory': scope.row.localInventory > 0 }">{{ scope.row.localInventory }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备货类型" width="92" align="center" sortable>
            <template slot-scope="scope">
              <el-tag :type="getStockCycleTagType(scope.row.stockCycleType)" size="mini" effect="plain">
                {{ getStockCycleLabel(scope.row.stockCycleType) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          ref="pageNav"
          layout="prev, pager, next, total"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-count="pageCount"
          :page-size="params.pageSize"
          :total="total"
          @prev-click="prevBtnClick"
          @next-click="nextBtnClick"
          @current-change="curBtnClick"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, colors, models } from "../../utils/constant.js";

export default {
  data() {
    return {
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      dataList: [],
      exportDataList: [],
      loading: false,
      params: {
        sku: "",
        productType: "",
        productColor: "",
        beginIndex: 0,
        pageSize: 300,
        stockCycleType: "",
      },
      productModel: "",
      total: 0,
      pageCount: 1,
      screenHeight: 400,
    };
  },
  watch: {
    "params.productType": {
      handler: function (newValue) {
        if (!newValue) {
          this.colorList = colors;
          this.modelList = models;
          return;
        }
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        if (!parentProduct) {
          return;
        }
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        let checkModels = Array.isArray(parentProduct.checkModels) ? parentProduct.checkModels : JSON.parse(parentProduct.checkModels);

        this.colorList = [];
        this.modelList = [...checkModels];

        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
    productModel: {
      handler: function (newValue) {
        if (!newValue) {
          this.params.productModel = "";
          return;
        }
        let blankReg = new RegExp(" ", "igm");
        this.params.productModel = newValue.replace(blankReg, "");
      },
    },
  },
  mounted() {
    this.getData();
    this.getExportData();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    getStockCycleLabel(stockCycleType) {
      let label = "";
      stockCycleType == 1 && (label = "平销");
      stockCycleType == 2 && (label = "做排名");
      stockCycleType == 3 && (label = "新品推广");
      stockCycleType == 4 && (label = "清库存");
      stockCycleType == 5 && (label = "禁止采购");
      stockCycleType == 6 && (label = "禁止出库");
      return label;
    },
    getStockCycleTagType(stockCycleType) {
      if (stockCycleType == 2 || stockCycleType == 3) {
        return "success";
      }
      if (stockCycleType == 4) {
        return "warning";
      }
      if (stockCycleType == 5 || stockCycleType == 6) {
        return "danger";
      }
      return "";
    },
    getSummaries(param) {
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout();
        }
      });
      const { columns, data } = param;
      const sums = [];
      const sumProps = new Set(["inPurchase", "localInventory"]);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (!column.property || !sumProps.has(column.property)) {
          sums[index] = "";
          return;
        }
        sums[index] = data.reduce((prev, item) => {
          const value = Number(item[column.property]);
          return !isNaN(value) ? prev + value : prev;
        }, 0);
      });
      return sums;
    },
    getData() {
      this.loading = true;
      requestModules
        .fetchLocalInventorys(this.params)
        .then(res => {
          this.dataList = res.ldata || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    getExportData() {
      requestModules.fetchLocalInventorys({ beginIndex: 0, pageSize: 100000 }).then(res => {
        this.exportDataList = res.ldata || [];
        this.exportDataList.forEach(item => {
          item.stockCycleTypeLabel = this.getStockCycleLabel(item.stockCycleType);
          item.shortageQuantityFor5 = item.localInventory % 5;
          item.shortageQuantityFor5 > 0 && (item.shortageQuantityFor5 = 5 - item.shortageQuantityFor5);

          let parentProduct = activeProducts.find(pd => pd.productType == item.productType);
          if (parentProduct) {
            item.perSKUOrderQuantity = parentProduct.perSKUOrderQuantity;

            item.shortageQuantityForPerSKU = item.localInventory % item.perSKUOrderQuantity;
            item.shortageQuantityForPerSKU > 0 && (item.shortageQuantityForPerSKU = item.perSKUOrderQuantity - item.shortageQuantityForPerSKU);
          }
        });
      });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
    getExportName() {
      return "本地库存表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
  },
  computed: {
    exportTitles() {
      let fields = {
        店铺名称: "shopName",
        产品名称: "productName",
        SKU: "sku",
        FNSKU: "fnsku",
        产品颜色: "productColorName",
        采购颜色: "purchaseColorName",
        机型: "model",
        采购数量: "inPurchase",
        本地库存数量: "localInventory",
        备货类型: "stockCycleTypeLabel",
        按5缺少数量: "shortageQuantityFor5",
        最低采购数量: "perSKUOrderQuantity",
        按最低采购数量缺少数量: "shortageQuantityForPerSKU",
      };
      return fields;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#LocalInventoryMgmt.local-inventory-mgmt-page {
  .breadcrumb-box {
    flex-shrink: 0;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;

    .el-breadcrumb {
      line-height: 1;
      font-size: 13px;
    }
  }

  .header-box {
    padding: 10px;
    height: auto;

    .filter-input-wide {
      width: 160px;
    }

    .filter-toolbar {
      margin-top: 4px;
      padding-top: 10px;
      border-top: 1px dashed #ebeef5;
    }

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }
  }

  .local-inventory-table {
    .table-header-cell {
      padding: 8px 0;
      line-height: 1.45;
    }

    .cell {
      padding-left: 10px;
      padding-right: 10px;
      line-height: 20px;
    }
  }

  .highlight-inventory {
    color: #409eff;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }
}
</style>
